"use strict";
/* IMPORT */
Object.defineProperty(exports, "__esModule", { value: true });
require("./changes_counters");
const proxy_watcher_1 = require("proxy-watcher");
const changes_subscriber_1 = require("./changes_subscriber");
const changes_subscribers_1 = require("./changes_subscribers");
const hooks_1 = require("./hooks");
/* STORE */
function store(store) {
    const [proxy] = proxy_watcher_1.watch(store, paths => {
        hooks_1.default.store.change.trigger(proxy, paths);
        changes.schedule(paths);
    });
    const changes = new changes_subscriber_1.default(proxy);
    changes_subscribers_1.default.set(proxy, changes);
    hooks_1.default.store.new.trigger(proxy);
    return proxy;
}
/* EXPORT */
exports.default = store;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic3RvcmUuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi9zcmMvc3RvcmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IjtBQUNBLFlBQVk7O0FBRVosOEJBQTRCO0FBQzVCLGlEQUFvQztBQUNwQyw2REFBcUQ7QUFDckQsK0RBQXVEO0FBQ3ZELG1DQUE0QjtBQUU1QixXQUFXO0FBRVgsU0FBUyxLQUFLLENBQXlCLEtBQVk7SUFFakQsTUFBTSxDQUFDLEtBQUssQ0FBQyxHQUFHLHFCQUFLLENBQUcsS0FBSyxFQUFFLEtBQUssQ0FBQyxFQUFFO1FBRXJDLGVBQUssQ0FBQyxLQUFLLENBQUMsTUFBTSxDQUFDLE9BQU8sQ0FBRyxLQUFLLEVBQUUsS0FBSyxDQUFFLENBQUM7UUFFNUMsT0FBTyxDQUFDLFFBQVEsQ0FBRyxLQUFLLENBQUUsQ0FBQztJQUU3QixDQUFDLENBQUMsQ0FBQztJQUVILE1BQU0sT0FBTyxHQUFHLElBQUksNEJBQWlCLENBQUcsS0FBSyxDQUFFLENBQUM7SUFFaEQsNkJBQWtCLENBQUMsR0FBRyxDQUFHLEtBQUssRUFBRSxPQUFPLENBQUUsQ0FBQztJQUUxQyxlQUFLLENBQUMsS0FBSyxDQUFDLEdBQUcsQ0FBQyxPQUFPLENBQUcsS0FBSyxDQUFFLENBQUM7SUFFbEMsT0FBTyxLQUFLLENBQUM7QUFFZixDQUFDO0FBRUQsWUFBWTtBQUVaLGtCQUFlLEtBQUssQ0FBQyJ9